import { DialogBase } from '../../../../common';
import { ModalComponent } from '../../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { QuestionnaireOrFeatureTitleAndDescription } from '../../../../common/components/QuestionnaireOrFeatureTitleAndDescription/QuestionnaireOrFeatureTitleAndDescription';

const USAInfoModal: ModalComponent = ({ onClose }) => {
  return (
    <DialogBase
      id="usa-info-modal"
      onClose={onClose}
      visual="secondary"
      size="small"
      title="US Person meaning"
    >
      <QuestionnaireOrFeatureTitleAndDescription subtitle="According to FATCA, an US person includes US tax residents, US citizens (even if residing outside the USA) and resident aliens of the USA." />
    </DialogBase>
  );
};

export { USAInfoModal };
